import getWithToken from './base/get-with-token'

const getCustomerActions = (id, page, limit) => getWithToken(`/customer/${id}/timeline/action?page=${page}&limit=${limit}`)()

export default getCustomerActions